import { render, staticRenderFns } from "./OrganizationDeleteModal.vue?vue&type=template&id=4c51d110&scoped=true&"
import script from "./OrganizationDeleteModal.vue?vue&type=script&lang=js&"
export * from "./OrganizationDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDeleteModal.vue?vue&type=style&index=0&id=4c51d110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51d110",
  null
  
)

export default component.exports